import { DOCUMENT_STATUS, IDENTIFICATION_LOCAL_STATUS, PROVIDER_TYPE, WORK_LIVE_STATUSES, WORK_STATUS } from "@/constants";
import { documentPhotoKey } from "@/utils/documentPhoto";
import { isAdditionalDocument } from "@/utils/media";
import { MEDIA_FILE_TYPE } from "../../constants";
import { IDENTIFICATION_RULES } from "../../constants/document";
import { CHECK_STATUS } from "../../router/constants";

export default {
  isOnline(state) {
    return state.isOnline;
  },
  isWorkChanging(state) {
    return [WORK_STATUS.STARTING, WORK_STATUS.STOPPING].includes(state.status);
  },

  isWorking(state) {
    return WORK_LIVE_STATUSES.includes(state.status);
  },
  isReconnecting(state) {
    return state.status === WORK_STATUS.RECONNECTING;
  },
  currentIdentification(state) {
    return state.identifications[state.identificationId];
  },
  currentIdentificationStatus(state, getters) {
    return getters.currentIdentification?.data?.status;
  },
  currentDocumentData(state, getters) {
    return getters.currentIdentification?.data?.document?.data;
  },
  identificationProviderType(state, getters) {
    return getters.currentDocumentData?.providerType;
  },
  isPhotoIdentification(state, getters) {
    const providerType = getters.identificationProviderType;
    return !providerType || providerType === PROVIDER_TYPE.PHOTO_IDENTIFICATION;
  },
  isDocumentEditEnabled(state) {
    return state.isDocumentEditEnabled;
  },
  isPOAEditEnabled(state) {
    return state.isPOAEditEnabled;
  },
  documentHasQr(state, getters) {
    const rule = getters.currentIdentification?.data?.rules?.find(rule => rule.name === IDENTIFICATION_RULES.HAS_QR);
    return rule?.status === CHECK_STATUS.SUCCESS;
  },
  currentDocumentValidity(state, getters) {
    const validations = getters.currentIdentification?.data?.document?.validations;
    const validationEntries = validations && Object.entries(validations);
    if (!validationEntries) return null;
    return validationEntries.reduce((acc, [key, value]) => {
      if (value?.some?.(({ isValid }) => isValid === false)) {
        acc[key] = false;
      } else if (value?.some?.(({ isValid }) => isValid === true)) {
        acc[key] = true;
      } else {
        acc[key] = null;
      }
      return acc;
    }, {});
  },
  currentIdentificationMediaByType(state, getters) {
    const media = getters.currentIdentification?.data?.media?.filter(item => !isAdditionalDocument(item) || item.fileType === MEDIA_FILE_TYPE.CUSTOM_IMAGE);

    if (!media) return;

    return media.reduce((result, item) => {
      const photoKey = documentPhotoKey(item);
      const attempts = item.verificationAttempts?.length ? item.verificationAttempts : [0];
      attempts.forEach(attempt => {
        if (!result[attempt]) result[attempt] = {};
        if (!result[attempt][photoKey]) result[attempt][photoKey] = [];
        result[attempt][photoKey].push(item);
      });
      return result;
    }, {});
  },
  documentUpdating(state, getters) {
    const identification = getters.currentIdentification;
    return DOCUMENT_STATUS.UPDATING === identification?.data?.document?.status;
  },
  isPoaUpdating(state, getters) {
    return DOCUMENT_STATUS.UPDATING === getters.currentIdentification?.data?.proofOfAddress?.status;
  },
  identificationUpdating(state, getters) {
    const identification = getters.currentIdentification;
    return [IDENTIFICATION_LOCAL_STATUS.LOADING, IDENTIFICATION_LOCAL_STATUS.APPROVING, IDENTIFICATION_LOCAL_STATUS.REJECTING].includes(identification?.status);
  },
  actionInProgress(state, getters) {
    return getters.identificationUpdating || getters.documentUpdating;
  },
  currentIdentificationRejectionReason(state, getters) {
    const identification = getters.currentIdentification;

    return identification?.data?.registration?.rejectionReason;
  }
};
